"use strict"
exports.__esModule = true;
exports.OutlinedFileVideoIconConfig = {
  name: 'OutlinedFileVideoIcon',
  height: 512,
  width: 384,
  svgPath: 'M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z',
  yOffset: 0,
  xOffset: 0,
};
exports.OutlinedFileVideoIcon = require('../createIcon').createIcon(exports.OutlinedFileVideoIconConfig);
exports["default"] = exports.OutlinedFileVideoIcon;